import Vue from 'vue';
import VueHtmlToPaper from "vue-html-to-paper";

const options = {
    name  : '_blank',
    specs : [],
    styles: [
        '/css/bootstrap.css',
    ]
}
Vue.use(VueHtmlToPaper, options);
